// extracted by mini-css-extract-plugin
module.exports = {"loader":"FigureMintingImage_loader__ePH6q","slide":"FigureMintingImage_slide__pDLqg","rotate":"FigureMintingImage_rotate__qgAiR"};